<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "JobTimeBanner",
    props: {
        doAction: {
            type: Function
        },
        isSalePage: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters(['getUser', 'getEmployeeAtWork']),
        getWeekDayNumber() {
            return new Date().getDay()
        }
    },
    methods: {
        ...mapActions(['putEmployeeAtWork']),
        finish(endTime) {
            let currentTime = new Date()
            let times = endTime.split(':')

            let employeeEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), +times[0], +times[1])

            if (currentTime > employeeEndTime) {
                this.finishWork()
            } else {
                this.$bvModal.show('finish_work')
            }

        },
        finishWork() {
            this.$root.showOverlay = true

            let data = {}
            data.id = this.getEmployeeAtWork.id
            data.endedAt = this.getCurrentTime()
            data.hasAtWork = false

            this
                .putEmployeeAtWork(data)
                .then(() => {
                    this.$root.showOverlay = false
                    this.$i18nHelper.toUrl('logout');
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        getCurrentTime() {
            let d = new Date()

            return this.addZero(d.getHours()) + ':' + this.addZero(d.getMinutes())
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
    }
}
</script>

<template>
    <div :class="isSalePage ? 'col-span-3 d-none d-xl-block rounded' : 'col-span-3 d-none d-xl-block mt-3 rounded bg-lightGray border'">
        <div
            v-if="getUser.person.employeeInformation && getEmployeeAtWork"
            class="">
            <div v-if="getEmployeeAtWork.hasAtWork" :class="isSalePage ? 'bg-white rounded py-3 px-3' : 'rounded py-3 px-1'">
                <div class="text-fontColor text-xl ml-3">
                    {{ $t('atWork.jobTime') }}:
                </div>
                <div class="flex justify-content-between px-1 mt-2">
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{ getUser.person.employeeInformation.startTime }}</span>
                        <span class="text-gray-400">{{ $t('atWork.from') }}</span>
                    </div>
                    <div>
                        <span class="text-2xl font-bold text-fontColor">{{ getUser.person.employeeInformation.endTime }}</span>
                        <span class="text-gray-400">{{ $t('atWork.to') }}</span>
                    </div>
                </div>

                <hr class="border-dashed mx-1" />

                <div class="flex justify-content-between px-2 text-xs">
                    <div :class="getWeekDayNumber === 1 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[1]') }}</div>
                    <div :class="getWeekDayNumber === 2 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[2]') }}</div>
                    <div :class="getWeekDayNumber === 3 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[3]') }}</div>
                    <div :class="getWeekDayNumber === 4 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[4]') }}</div>
                    <div :class="getWeekDayNumber === 5 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[5]') }}</div>
                    <div :class="getWeekDayNumber === 6 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[6]') }}</div>
                    <div :class="getWeekDayNumber === 0 ? 'bg-warning px-2 text-white rounded-lg' : ''">{{ $t('statistics.weekdays[0]') }}</div>
                </div>

                <div class="px-2 mt-3">
                    <b-progress :value="getWeekDayNumber === 0 ? 7 : getWeekDayNumber" :max="7" variant="warning" class="h-2" ></b-progress>
                </div>

                <div class="flex justify-content-center mt-3 px-1">
                    <b-button @click="finish(getUser.person.employeeInformation.endTime)" class="bg-main hover:bg-hoverMain w-full rounded border-0 focus:ring-0 text-white font-bold focus:bg-main">
                        {{ $t('atWork.closeNow') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>